function readRuntimeEnv(name: 'VITE_API_URL'): string {
  const value = (import.meta as ImportMeta & { env?: Record<string, unknown> }).env?.[name];
  return typeof value === 'string' && value.length > 0 ? value : 'http://localhost:3000';
}

function normalizeBaseUrl(baseUrl: URL): URL {
  const normalized = new URL(baseUrl.href);

  if (!normalized.pathname.endsWith('/')) {
    normalized.pathname = `${normalized.pathname}/`;
  }

  return normalized;
}

function buildHttpUrl(baseUrl: URL, pathname: string): URL {
  return new URL(pathname, normalizeBaseUrl(baseUrl));
}

function buildWebSocketUrl(baseUrl: URL, pathname: string): URL {
  const url = buildHttpUrl(baseUrl, pathname);
  url.protocol = baseUrl.protocol === 'https:' ? 'wss:' : 'ws:';
  return url;
}

class RuntimeUrls {
  public readonly apiUrl: URL;

  constructor() {
    this.apiUrl = new URL(readRuntimeEnv('VITE_API_URL'));
  }

  public getAdminAuthMeUrl(): string {
    return buildHttpUrl(this.apiUrl, 'admin/auth/me').href;
  }

  public getGoogleLoginUrl(): string {
    const url = buildHttpUrl(this.apiUrl, 'auth/google');
    url.searchParams.set('returnTo', 'admin');
    return url.href;
  }

  public getAdminWebSocketUrl(): URL {
    return buildWebSocketUrl(this.apiUrl, 'admin/ws');
  }
}

export const runtimeUrls = new RuntimeUrls();
